export default "__VITE_ASSET__BoN9tIRn__"